export default __webpack_public_path__ + "static/media/4_banner-dev-mobile.5c786d44.jpg";